import React from "react";
import PropTypes from "prop-types";
import { defineMessages } from "react-intl";
import { ArrowDropDownIcon } from "../../../theme/assets";
import classnames from "classnames";
import styles from "./Tab.scss";

export const msgs = defineMessages({
  filter: {
    id: "booking_form.tabs_filter.filter",
    description: "Filter",
    defaultMessage: "Filter",
  },
});

function Tab({ filter, selected, handleChange, handleSelectorChange, isTabFiltersCollapsed }) {
  const propertyTabs = filter && filter.get("options");

  if (!propertyTabs || propertyTabs.size < 1) {
    return null;
  }

  return (
    <div className={classnames("wbkv9-FilterTab-container", styles.container)}>
      {!isTabFiltersCollapsed && (
        <div className={classnames("wbkv9-FilterTab-wrapper", styles.wrapper)}>
          {propertyTabs.map((tab, idx) => {
            const active = selected === tab.get("optionTicker");

            return (
              <div
                key={idx}
                className={classnames(
                  "wbkv9-FilterTab-element",
                  styles.element,
                  active && "active",
                  active && styles.active
                )}
                onClick={() => handleChange(tab.get("optionTicker"))}>
                {tab.get("optionName")}
              </div>
            );
          })}
        </div>
      )}

      {isTabFiltersCollapsed && (
        <div className={classnames("wbkv9-FilterTab-selectorContainer", styles.selectorContainer)}>
          <select
            className={classnames("wbkv9-FilterTab-selector", styles.selector)}
            value={selected}
            onChange={event => handleSelectorChange(event)}>
            {propertyTabs.map((tab, idx) => (
              <option key={idx} value={tab.get("optionTicker")}>
                {tab.get("optionName")}
              </option>
            ))}
          </select>

          <div className={classnames("wbkv9-FilterTab-arrowDown", styles.arrowDown)}>
            <ArrowDropDownIcon />
          </div>
        </div>
      )}
    </div>
  );
}

Tab.propTypes = {
  filter: PropTypes.object,
  selected: PropTypes.string,
  isTabFiltersCollapsed: PropTypes.bool,
  hasTitle: PropTypes.bool,
  handleChange: PropTypes.func,
  handleSelectorChange: PropTypes.func,
};

export default Tab;
